import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/Spelling/SpellingLevel.png";
import PracticeGame from "../../components/MP_PracticeGame";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";
import Keyboard from "../../components/Keyboard";
import useSpeech from "../../hooks/useSpeech";

var alphabetFull = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];

export default function Multiplayer({ ...props }) {
  const game = props.game;
  console.log(props);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  //const [realQuestions, setRealQuestions] = useState();
  const [workAround, setWorkAround] = useState(false);
  const [place, setPlace] = useState(0);
  //const { sayWord } = useSpeech();
  //const [currQuestion, setCurrentQuestion] = useState([]);
  const [wordToSay, setWordToSay] = useState("");
  const [extraChars, setExtraChars] = useState([]);
  const [SetupQuestions, setSetupQuestons] = useState(false);

  async function checkResult(value, callback) {
    let isCorrect = true;
    if (value) {
      if (currentQuestion.word === value) {
        setCorrectQuestions([...correctQuestions, currentQuestion]);
        isCorrect = true;
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);
        if (multiplier != 0 && multiplier != undefined)
          props.SubmitScore(multiplier * 10);
        setCombo(combo + 1);
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
      } else {
        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        isCorrect = false;
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }
        let result = {
          question: currentQuestion.sentence.replace("$", " _ "),
          correct: currentQuestion.word,
          incorrect: value
        };
        setFeedback([...feedback, result]);
      }

      if (callback) {
        await callback(isCorrect).then(() => {
          newQuestion();
        });
      } else {
        newQuestion();
      }
    }
  }


  function GetListOfPositions() {
    //order the scores
    //console.log(props);
    //var web = props.parent.getwebrtc();
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    // console.log(webcopy);
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    //console.log(webcopy);
    //replace yourname with YOU
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username)
        webcopy[i].username = "You"
    }
    var scoreText = [];
    for (let i = 0; i < webcopy.length; i++) {
      let temptext = webcopy[i].username + ": " + webcopy[i].score
      scoreText.push(temptext);
    }
    // console.log(scoreText);
    const listItems = scoreText.map((i) =>
      <li>{i}</li>
    );

    return listItems;
  }

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    var current = currentQuestion.word;
    var newQuestion = "";
    var getNewQuestion = true;

    while (getNewQuestion) {
      var difficulty = Math.floor(Math.random() * questions.length);
      var questionNum = Math.floor(Math.random() * questions[difficulty].length)
      var sample = questions[difficulty][questionNum];
      console.log(sample);
      if (sample.word !== current) {
        setCurrentQuestion(sample);
        getNewQuestion = false;
      }
    }
  }

  function getExtraChars(word, level) {
    let alphabet = [
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z"
    ];

    //remove the characters of the current answer from the alphabet
    let remainingChars = alphabet.filter(function (el) {
      return !word.includes(el);
    });

    // worh out the number of extra characters to add
    // Level x character in current word
   // const extraChars = [];

    if (level > 1) {
      const wordLength = word.length;
      const extraCharCount = wordLength * (props.level - 1);
      for (var i = 0; i < extraCharCount; i++) {
        if (remainingChars.length > 0) {
          let char =
            remainingChars[Math.floor(Math.random() * remainingChars.length)];
          //extraChars.push(char);
          remainingChars = remainingChars.filter(function (x) {
            return char.indexOf(x) < 0;
          });
        }
      }
    }
    return extraChars;
  }


  function GetPlace() {
    var position = 0;
    //order the scores
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    console.log(webcopy);
    //gets your position in the list
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username) {
        setPlace(i + 1);
        position = i + 1;
      }

    }
    console.log(place);
    console.log(position);
    return position;
  }

  //     set the first question
  useEffect(() => {
    console.log("set first");
    if (questions !== undefined && questions.length > 0) {
      setCurrentQuestion(questions[0][0]);
      setWordToSay(currentQuestion.word);
      console.log(questions[0][0])
      console.log(questions);
      setSetupQuestons(true);
    }
  }, [questions]);

  //when question changes play the relevant audio
  useEffect(() => {
    console.log("set word to say");
    setWordToSay(currentQuestion.word);
    sayWord(currentQuestion.word);
    //currentQuestion.word !== undefined &&
      //setExtraChars(getExtraChars(currentQuestion.word.split(""), props.level));
  }, [currentQuestion]);

  useEffect(() => {
    console.log("say word");
    sayWord(wordToSay);
  }, [wordToSay]);

    function ComboImage() {
        console.log(props);
        let comboNum = combo;
        if (combo > 4)
            comboNum = 4;
        var imageName = props.game.animation_path + "/combo" + comboNum + ".gif";
        //return <img src= {{imageName}} style={{position:"relative"}}></img>
        console.log("../../assets/"+imageName)
            return (require("../../assets/"+imageName))
    }

     function sayWord(word) {
    if (word != undefined && word != "") {
        word = word.toLowerCase();
        console.log("playing sound: " + word);
        try {
            // Updated to use the public folder path
            var audio = new Audio("/audio/" + word + '.mp3'); 
            audio.play();
        } catch (error) {
            var msg = new SpeechSynthesisUtterance();
            msg.text = word;
            window.speechSynthesis.speak(msg);
        }
    }
}


  return (
    <PracticeGame
    parent={props}
      loading={!questions}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => props.onBack()}
      defaultTimer={60}
      restart={() => {
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
      }}
      feedback={feedback}
      homework_id={props.homework_id}
      questionFontSize="0.7em"
      getplace={() => GetPlace()}
    >
      <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
      <Body>
        <FormContent style={{ right: "100px", position: "relative", top: "0px", width: "200px", height: "50%" }}>
          <br></br>
          {GetListOfPositions()}
        </FormContent>
        <div>{SetupQuestions == true ? (

          <Keyboard
            currentQuestion={currentQuestion}
            onSubmitted={checkResult}
            playAudioButton={true}
            onPlayAudio={() => {
                setWordToSay(wordToSay);
                sayWord(wordToSay);
            }}
            additionalCharacters={alphabetFull}
          />

        ) : <h1>help</h1>}
        </div>
        <Combo>
          <span style={{ fontSize: "50px" }}>{combo}</span>
          <span style={{ fontSize: "20px" }}>COMBO</span>
        </Combo>
      </Body>
      </div>
    </PracticeGame>
  );
}

const Body = styled.div`
font-family: "PrimerPrint";
    width: 100%;
    height: 100%;
    background-image: url();
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;
